var CSSCONSTANTS = CSSCONSTANTS || {};

(function () {

    /* used by backToTop.js */
    CSSCONSTANTS.backToTopLinkClass = 'back-to-top-link';
    CSSCONSTANTS.globalFooterClass = 'global-footer';

    /* used by brianModule.js */
    CSSCONSTANTS.brianModuleClass = 'brian-module';
    CSSCONSTANTS.withBrianModuleClass = 'with-brian-module';

    /* used by brianModule.js and equalizeHeights.js */
    CSSCONSTANTS.equalizeHeightDesktopClass = 'js-equalizeHeight-desktop';
    CSSCONSTANTS.equalizeHeightSetDesktopClass = 'js-equalizeHeightSet-desktop';

    /* used by equalizeHeights.js */
    CSSCONSTANTS.equalizeHeightNonMobileClass = 'js-equalizeHeight-non-mobile';
    CSSCONSTANTS.equalizeHeightSetNonMobileClass = 'js-equalizeHeightSet-non-mobile';

    /* only used by expandingPanel.js */
    CSSCONSTANTS.expandingPanelClass = 'expanding-panel';
    CSSCONSTANTS.expandingPanelHeadingClass = 'expanding-panel__heading';
    CSSCONSTANTS.expandingPanelHeadingLinkClass = 'expanding-panel__heading__link';
    CSSCONSTANTS.expandingPanelHeadingOpenClass = 'expanding-panel__heading--open';
    CSSCONSTANTS.expandingPanelHeadingClosedClass = 'expanding-panel__heading--closed';
    CSSCONSTANTS.expandingPanelContentClass = 'expanding-panel__content';

    /* only used by videoEmbed.js */
    CSSCONSTANTS.videoClass = 'video';
    CSSCONSTANTS.videoBasicClass = 'video--basic';
    CSSCONSTANTS.videoControlsClass = 'video__controls';
    CSSCONSTANTS.videoPlaceholderClass = 'video__placeholder';
    CSSCONSTANTS.flexiMediaWrapperClass = 'flexi-media-wrapper';

    /* only used by socialShare.js */
    CSSCONSTANTS.socialShareTriggerOpenClass = 'social-share__option--select__trigger--open';
    CSSCONSTANTS.optionsDropdownTriggerClass = 'social-share__option--select__trigger';
    CSSCONSTANTS.socialLinkEmailClass = 'social-link--Email';
    CSSCONSTANTS.socialLinkPrintClass = 'social-link--Print';
    CSSCONSTANTS.socialShareOptionDropdownClass = 'social-share__option--select__dropdown';
    CSSCONSTANTS.socialShareOptionDropdownCloseClass = 'social-share__option--select__dropdown__close';

    /* only used by responsiveTables.js */
    CSSCONSTANTS.hideColumnOnMobileClass = 'hide-column-on-mobile';
    CSSCONSTANTS.hideColumnOnTabletAndMobileClass = 'hide-column-on-tablet-and-mobile';
    CSSCONSTANTS.fauxTableHeaderClass = 'faux-table-header';
    CSSCONSTANTS.responsiveTableVerticalClass = 'responsive-table--vertical';

    /* used by figures.js */
    CSSCONSTANTS.cmsContentClass = 'cms-content';

    /* only used by overlaps.js */
    CSSCONSTANTS.overlapBandAboveClass = 'js-overlap-band-above';
    CSSCONSTANTS.overlapBandAboveNonMobileClass = 'js-overlap-band-above--non-mobile';

})();